"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.approveBulletin = approveBulletin;
exports.cancelHandout = cancelHandout;
exports.communityWatcher = communityWatcher;
exports.createBulletin = createBulletin;
exports.createNotice = createNotice;
exports.createNoticeDraft = createNoticeDraft;
exports.deleteNoticeDraft = deleteNoticeDraft;
exports.denyBulletin = denyBulletin;
exports.editNoticeDraft = editNoticeDraft;
exports.getBulletin = getBulletin;
exports.getNotice = getNotice;
exports.listBulletins = listBulletins;
exports.listBulletinsRequests = listBulletinsRequests;
exports.listExpiredNotices = listExpiredNotices;
exports.listNotices = listNotices;
exports.listUpcomingNotices = listUpcomingNotices;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _helpers = require("@qwkin/helpers");
var _variables = require("../../Notification/variables");
var _utils = require("../../../utils");
var _variables2 = require("../variables");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(communityWatcher);
function deleteNoticeDraft(_ref) {
  var payload = _ref.payload,
    _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? _helpers.identity : _ref$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.put)({
            type: _variables2.DELETE_NOTICE_DRAFT_SUCCESS,
            payload: payload
          });
        case 3:
          _context.next = 5;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Notice draft deleted successfully'
            }
          });
        case 5:
          callback();
          _context.next = 15;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          _context.next = 12;
          return (0, _effects.put)({
            type: _variables2.DELETE_NOTICE_DRAFT_FAIL,
            payload: _context.t0
          });
        case 12:
          _context.next = 14;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: 'Error deleting draft'
            }
          });
        case 14:
          (0, _utils.logErr)(_context.t0);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  })();
}
function editNoticeDraft(_ref2) {
  var payload = _ref2.payload,
    _ref2$callback = _ref2.callback,
    callback = _ref2$callback === void 0 ? _helpers.identity : _ref2$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.put)({
            type: _variables2.EDIT_NOTICE_DRAFT_SUCCESS,
            payload: payload
          });
        case 3:
          _context2.next = 5;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Notice draft edited successfully'
            }
          });
        case 5:
          callback();
          _context2.next = 15;
          break;
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 12;
          return (0, _effects.put)({
            type: _variables2.EDIT_NOTICE_DRAFT_FAIL,
            payload: _context2.t0
          });
        case 12:
          _context2.next = 14;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: 'Error editing draft'
            }
          });
        case 14:
          (0, _utils.logErr)(_context2.t0);
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 8]]);
  })();
}
function createNoticeDraft(_ref3) {
  var payload = _ref3.payload,
    _ref3$callback = _ref3.callback,
    callback = _ref3$callback === void 0 ? _helpers.identity : _ref3$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)({
            type: _variables2.CREATE_NOTICE_DRAFT_SUCCESS,
            payload: payload
          });
        case 3:
          _context3.next = 5;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Notice draft created successfully'
            }
          });
        case 5:
          callback();
          _context3.next = 15;
          break;
        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 12;
          return (0, _effects.put)({
            type: _variables2.CREATE_NOTICE_DRAFT_FAIL,
            payload: _context3.t0
          });
        case 12:
          _context3.next = 14;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: 'Error creating draft'
            }
          });
        case 14:
          (0, _utils.logErr)(_context3.t0);
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 8]]);
  })();
}
function createNotice(_ref4) {
  var payload = _ref4.payload,
    _ref4$callback = _ref4.callback,
    callback = _ref4$callback === void 0 ? _helpers.identity : _ref4$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.CommunityService.createNotice, payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables2.CREATE_NOTICE_SUCCESS,
            payload: response
          });
        case 6:
          _context4.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Notice created successfully'
            }
          });
        case 8:
          callback();
          _context4.next = 19;
          break;
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          _response = _context4.t0.response;
          _context4.next = 16;
          return (0, _effects.put)({
            type: _variables2.CREATE_NOTICE_FAIL,
            payload: _response
          });
        case 16:
          _context4.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 18:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 19:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 11]]);
  })();
}
function createBulletin(_ref6) {
  var payload = _ref6.payload,
    _ref6$callback = _ref6.callback,
    callback = _ref6$callback === void 0 ? _helpers.identity : _ref6$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.CommunityService.createBulletin, payload);
        case 3:
          response = _context5.sent;
          _context5.next = 6;
          return (0, _effects.put)({
            type: _variables2.CREATE_BULLETIN_SUCCESS,
            payload: response
          });
        case 6:
          _context5.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Bulletin created successfully'
            }
          });
        case 8:
          callback();
          _context5.next = 19;
          break;
        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](0);
          _response2 = _context5.t0.response;
          _context5.next = 16;
          return (0, _effects.put)({
            type: _variables2.CREATE_BULLETIN_FAIL,
            payload: _response2
          });
        case 16:
          _context5.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 18:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 19:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 11]]);
  })();
}
function denyBulletin(_ref8) {
  var payload = _ref8.payload,
    _ref8$callback = _ref8.callback,
    callback = _ref8$callback === void 0 ? _helpers.identity : _ref8$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.CommunityService.denyHandout, payload);
        case 3:
          response = _context6.sent;
          _context6.next = 6;
          return (0, _effects.put)({
            type: _variables2.DENY_BULLETIN_SUCCESS,
            payload: response
          });
        case 6:
          _context6.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Bulletin denied successfully'
            }
          });
        case 8:
          callback();
          _context6.next = 19;
          break;
        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](0);
          _response3 = _context6.t0.response;
          _context6.next = 16;
          return (0, _effects.put)({
            type: _variables2.DENY_BULLETIN_FAIL,
            payload: _response3
          });
        case 16:
          _context6.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 18:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 19:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 11]]);
  })();
}
function cancelHandout(_ref10) {
  var payload = _ref10.payload,
    _ref10$callback = _ref10.callback,
    callback = _ref10$callback === void 0 ? _helpers.identity : _ref10$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
    var response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_services.CommunityService.cancelHandout, payload);
        case 3:
          response = _context7.sent;
          _context7.next = 6;
          return (0, _effects.put)({
            type: _variables2.CANCEL_HANDOUT_SUCCESS,
            payload: response
          });
        case 6:
          _context7.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Handout canceled successfully'
            }
          });
        case 8:
          callback();
          _context7.next = 19;
          break;
        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7["catch"](0);
          _response4 = _context7.t0.response;
          _context7.next = 16;
          return (0, _effects.put)({
            type: _variables2.CANCEL_HANDOUT_FAIL,
            payload: _response4
          });
        case 16:
          _context7.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 18:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 19:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 11]]);
  })();
}
function approveBulletin(_ref12) {
  var payload = _ref12.payload,
    _ref12$callback = _ref12.callback,
    callback = _ref12$callback === void 0 ? _helpers.identity : _ref12$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
    var response, _response5$data, _response5$data2, _response5;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_services.CommunityService.approveHandout, payload);
        case 3:
          response = _context8.sent;
          _context8.next = 6;
          return (0, _effects.put)({
            type: _variables2.APPROVE_BULLETIN_SUCCESS,
            payload: response
          });
        case 6:
          _context8.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Bulletin approved successfully'
            }
          });
        case 8:
          callback();
          _context8.next = 19;
          break;
        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](0);
          _response5 = _context8.t0.response;
          _context8.next = 16;
          return (0, _effects.put)({
            type: _variables2.APPROVE_BULLETIN_FAIL,
            payload: _response5
          });
        case 16:
          _context8.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response5$data = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data !== void 0 ? _response5$data : {}),
              data: _response5
            }
          });
        case 18:
          (0, _utils.logErr)((_response5$data2 = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data2 !== void 0 ? _response5$data2 : {});
        case 19:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 11]]);
  })();
}
function getBulletin(_ref14) {
  var payload = _ref14.payload,
    _ref14$callback = _ref14.callback,
    callback = _ref14$callback === void 0 ? _helpers.identity : _ref14$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
    var response, _response6$data, _response6$data2, _response6;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(_services.CommunityService.getHandoutById, payload);
        case 3:
          response = _context9.sent;
          _context9.next = 6;
          return (0, _effects.put)({
            type: _variables2.GET_BULLETIN_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context9.next = 17;
          break;
        case 9:
          _context9.prev = 9;
          _context9.t0 = _context9["catch"](0);
          _response6 = _context9.t0.response;
          _context9.next = 14;
          return (0, _effects.put)({
            type: _variables2.GET_BULLETIN_FAIL,
            payload: _response6
          });
        case 14:
          _context9.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response6$data = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data !== void 0 ? _response6$data : {}),
              data: _response6
            }
          });
        case 16:
          (0, _utils.logErr)((_response6$data2 = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data2 !== void 0 ? _response6$data2 : {});
        case 17:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 9]]);
  })();
}
function getNotice(_ref16) {
  var payload = _ref16.payload,
    _ref16$callback = _ref16.callback,
    callback = _ref16$callback === void 0 ? _helpers.identity : _ref16$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
    var response, _response7$data, _response7$data2, _response7;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.call)(_services.CommunityService.getHandoutById, payload);
        case 3:
          response = _context10.sent;
          _context10.next = 6;
          return (0, _effects.put)({
            type: _variables2.GET_NOTICE_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context10.next = 17;
          break;
        case 9:
          _context10.prev = 9;
          _context10.t0 = _context10["catch"](0);
          _response7 = _context10.t0.response;
          _context10.next = 14;
          return (0, _effects.put)({
            type: _variables2.GET_NOTICE_FAIL,
            payload: _response7
          });
        case 14:
          _context10.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response7$data = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data !== void 0 ? _response7$data : {}),
              data: _response7
            }
          });
        case 16:
          (0, _utils.logErr)((_response7$data2 = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data2 !== void 0 ? _response7$data2 : {});
        case 17:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 9]]);
  })();
}
function listNotices(_ref18) {
  var payload = _ref18.payload,
    _ref18$callback = _ref18.callback,
    callback = _ref18$callback === void 0 ? _helpers.identity : _ref18$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
    var response, _response8$data, _response8$data2, _response8;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _context11.next = 3;
          return (0, _effects.call)(_services.CommunityService.listHandouts, payload);
        case 3:
          response = _context11.sent;
          _context11.next = 6;
          return (0, _effects.put)({
            type: _variables2.LIST_NOTICES_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context11.next = 17;
          break;
        case 9:
          _context11.prev = 9;
          _context11.t0 = _context11["catch"](0);
          _response8 = _context11.t0.response;
          _context11.next = 14;
          return (0, _effects.put)({
            type: _variables2.LIST_NOTICES_FAIL,
            payload: _response8
          });
        case 14:
          _context11.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response8$data = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data !== void 0 ? _response8$data : {}),
              data: _response8
            }
          });
        case 16:
          (0, _utils.logErr)((_response8$data2 = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data2 !== void 0 ? _response8$data2 : {});
        case 17:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[0, 9]]);
  })();
}
function listExpiredNotices(_ref20) {
  var payload = _ref20.payload,
    _ref20$callback = _ref20.callback,
    callback = _ref20$callback === void 0 ? _helpers.identity : _ref20$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
    var response, _response9$data, _response9$data2, _response9;
    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.call)(_services.CommunityService.listHandouts, payload);
        case 3:
          response = _context12.sent;
          _context12.next = 6;
          return (0, _effects.put)({
            type: _variables2.LIST_EXPIRED_NOTICES_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context12.next = 17;
          break;
        case 9:
          _context12.prev = 9;
          _context12.t0 = _context12["catch"](0);
          _response9 = _context12.t0.response;
          _context12.next = 14;
          return (0, _effects.put)({
            type: _variables2.LIST_EXPIRED_NOTICES_FAIL,
            payload: _response9
          });
        case 14:
          _context12.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response9$data = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data !== void 0 ? _response9$data : {}),
              data: _response9
            }
          });
        case 16:
          (0, _utils.logErr)((_response9$data2 = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data2 !== void 0 ? _response9$data2 : {});
        case 17:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 9]]);
  })();
}
function listUpcomingNotices(_ref22) {
  var payload = _ref22.payload,
    _ref22$callback = _ref22.callback,
    callback = _ref22$callback === void 0 ? _helpers.identity : _ref22$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
    var response, _response10$data, _response10$data2, _response10;
    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 3;
          return (0, _effects.call)(_services.CommunityService.listHandouts, payload);
        case 3:
          response = _context13.sent;
          _context13.next = 6;
          return (0, _effects.put)({
            type: _variables2.LIST_UPCOMING_NOTICES_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context13.next = 17;
          break;
        case 9:
          _context13.prev = 9;
          _context13.t0 = _context13["catch"](0);
          _response10 = _context13.t0.response;
          _context13.next = 14;
          return (0, _effects.put)({
            type: _variables2.LIST_UPCOMING_NOTICES_FAIL,
            payload: _response10
          });
        case 14:
          _context13.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response10$data = _response10 === null || _response10 === void 0 ? void 0 : _response10.data) !== null && _response10$data !== void 0 ? _response10$data : {}),
              data: _response10
            }
          });
        case 16:
          (0, _utils.logErr)((_response10$data2 = _response10 === null || _response10 === void 0 ? void 0 : _response10.data) !== null && _response10$data2 !== void 0 ? _response10$data2 : {});
        case 17:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 9]]);
  })();
}
function listBulletinsRequests(_ref24) {
  var payload = _ref24.payload,
    _ref24$callback = _ref24.callback,
    callback = _ref24$callback === void 0 ? _helpers.identity : _ref24$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
    var response, _response11$data, _response11$data2, _response11;
    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return (0, _effects.call)(_services.CommunityService.listHandouts, payload);
        case 3:
          response = _context14.sent;
          _context14.next = 6;
          return (0, _effects.put)({
            type: _variables2.LIST_BULLETINS_REQUESTS_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context14.next = 17;
          break;
        case 9:
          _context14.prev = 9;
          _context14.t0 = _context14["catch"](0);
          _response11 = _context14.t0.response;
          _context14.next = 14;
          return (0, _effects.put)({
            type: _variables2.LIST_BULLETINS_REQUESTS_FAIL,
            payload: _response11
          });
        case 14:
          _context14.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response11$data = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data !== void 0 ? _response11$data : {}),
              data: _response11
            }
          });
        case 16:
          (0, _utils.logErr)((_response11$data2 = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data2 !== void 0 ? _response11$data2 : {});
        case 17:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 9]]);
  })();
}
function listBulletins(_ref26) {
  var payload = _ref26.payload,
    _ref26$callback = _ref26.callback,
    callback = _ref26$callback === void 0 ? _helpers.identity : _ref26$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
    var response, _response12$data, _response12$data2, _response12;
    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return (0, _effects.call)(_services.CommunityService.listHandouts, payload);
        case 3:
          response = _context15.sent;
          _context15.next = 6;
          return (0, _effects.put)({
            type: _variables2.LIST_BULLETINS_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context15.next = 17;
          break;
        case 9:
          _context15.prev = 9;
          _context15.t0 = _context15["catch"](0);
          _response12 = _context15.t0.response;
          _context15.next = 14;
          return (0, _effects.put)({
            type: _variables2.LIST_BULLETINS_FAIL,
            payload: _response12
          });
        case 14:
          _context15.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response12$data = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data !== void 0 ? _response12$data : {}),
              data: _response12
            }
          });
        case 16:
          (0, _utils.logErr)((_response12$data2 = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data2 !== void 0 ? _response12$data2 : {});
        case 17:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[0, 9]]);
  })();
}
function communityWatcher() {
  return _regenerator["default"].wrap(function communityWatcher$(_context16) {
    while (1) switch (_context16.prev = _context16.next) {
      case 0:
        _context16.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables2.LIST_NOTICES_REQUEST, listNotices), (0, _effects.takeLatest)(_variables2.LIST_EXPIRED_NOTICES_REQUEST, listExpiredNotices), (0, _effects.takeLatest)(_variables2.LIST_UPCOMING_NOTICES_REQUEST, listUpcomingNotices), (0, _effects.takeLatest)(_variables2.LIST_BULLETINS_REQUEST, listBulletins), (0, _effects.takeLatest)(_variables2.LIST_BULLETINS_REQUESTS_REQUEST, listBulletinsRequests), (0, _effects.takeLatest)(_variables2.GET_NOTICE_REQUEST, getNotice), (0, _effects.takeLatest)(_variables2.GET_BULLETIN_REQUEST, getBulletin), (0, _effects.takeLatest)(_variables2.CREATE_BULLETIN_REQUEST, createBulletin), (0, _effects.takeLatest)(_variables2.CREATE_NOTICE_REQUEST, createNotice), (0, _effects.takeLatest)(_variables2.APPROVE_BULLETIN_REQUEST, approveBulletin), (0, _effects.takeLatest)(_variables2.DENY_BULLETIN_REQUEST, denyBulletin), (0, _effects.takeLatest)(_variables2.CANCEL_HANDOUT_REQUEST, cancelHandout), (0, _effects.takeLatest)(_variables2.CREATE_NOTICE_DRAFT_REQUEST, createNoticeDraft), (0, _effects.takeLatest)(_variables2.EDIT_NOTICE_DRAFT_REQUEST, editNoticeDraft), (0, _effects.takeLatest)(_variables2.DELETE_NOTICE_DRAFT_REQUEST, deleteNoticeDraft)]);
      case 2:
      case "end":
        return _context16.stop();
    }
  }, _marked);
}